import React from 'react';
import { Gift, Heart, ExternalLink, Star } from 'lucide-react';

const GiftCards = () => {
  const handleGiftCardPurchase = () => {
    window.open('https://www.toasttab.com/hot-slice-pizza-41-dravus-street/giftcards', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="gift-cards" className="py-12 sm:py-16 bg-gradient-to-r from-red-600 to-orange-600 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-24 h-24 bg-white rounded-full blur-2xl animate-float"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-white rounded-full blur-2xl animate-float" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          {/* Header */}
          <div className="flex items-center justify-center space-x-3 mb-4">
            <Gift className="h-8 w-8 text-white animate-bounce" />
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Gift <span className="text-yellow-300">Cards</span>
            </h2>
          </div>
          
          <p className="text-lg text-orange-100 mb-8 leading-relaxed">
            Share the joy of authentic NY style cuisine! Perfect for birthdays, holidays, 
            or any special occasion. Give your loved ones the gift of delicious food.
          </p>

          {/* Features */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 mb-8">
            <div className="flex items-center space-x-2 text-orange-100">
              <Heart className="h-5 w-5 text-pink-300" />
              <span className="text-sm">Perfect for Any Occasion</span>
            </div>
            <div className="flex items-center space-x-2 text-orange-100">
              <Star className="h-5 w-5 text-yellow-300" />
              <span className="text-sm">Never Expires</span>
            </div>
            <div className="flex items-center space-x-2 text-orange-100">
              <Gift className="h-5 w-5 text-green-300" />
              <span className="text-sm">Digital Delivery</span>
            </div>
          </div>

          {/* Call to Action */}
          <button
            onClick={handleGiftCardPurchase}
            className="group bg-white hover:bg-gray-100 text-red-600 px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl flex items-center space-x-3 mx-auto"
          >
            <Gift className="h-6 w-6 group-hover:animate-bounce" />
            <span>Purchase Gift Cards</span>
            <ExternalLink className="h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
          </button>
          
          <p className="text-orange-200 text-sm mt-4">
            Available in any amount • Digital delivery • Never expires
          </p>
        </div>
      </div>
    </section>
  );
};

export default GiftCards;